module.exports = __webpack_public_path__ + "202268e82189b6d5023b6866101f9259.png";